<div class="o-grid o-grid--wrap" *ngIf="vm.initialized">
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-33@md-and-up u-no-p">
		<div class="o-grid o-grid--column">
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<section class="c-section c-section--first" panel [isOpen]="vm.isOpen?.service">
					<div class="c-section__header">
						<div id="benuLogoContainer" *ngIf="vm.thirdPartyRenewal === 'benu'">
							<img id="benuLogo1" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 20%" class="u-hidden@md-and-up">
							<img id="benuLogo2" src="https://dqs3afosyxqoy.cloudfront.net/assets/minudoc/account/img/logo/benu-logo.png" style="max-width: 45%" class="u-hidden@up-to-md">
						</div>
						<h1 class="c-section__title c-section__title--sm">{{ 'Booking.Title.Service' | translate }}</h1>
					</div>
					<div class="c-section__content">
						<!-- Service booking -->
						<div class="o-grid" *ngIf="vm.booking?.service">
							<div class="o-grid__cell c-cell u-no-mt">
								<card-service [service]="vm.booking.service" [isMinimal]="true"></card-service>
							</div>
						</div>
						<!-- Instant booking -->
						<div class="o-grid" *ngIf="vm.booking && !vm.booking.service">
							<div class="o-grid__cell c-cell u-no-mt">
								<div class="c-card">
									<div class="c-content">
										<div class="o-grid o-grid--wrap o-grid--center-v">
											<div class="o-grid__cell u-no-p">
												<p class="c-text" *ngIf="!vm.isPrescription">{{ vm.booking.category?.translation }}</p>
												<p class="c-text" *ngIf="vm.isPrescription">{{ 'Booking.Prescription.Title' | translate }}</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
												<p class="c-text c-text--main">
													<span class="c-text c-text--bold c-text--lg" *ngIf="vm.user?.origin == 'minudoc.ee' || !(vm.businessWallet && vm.canPayWithBusinessWallet)">{{ vm.booking.price }}{{ vm.booking.currency }}</span>
													<span *ngIf="!vm.isPrescription">/{{ vm.booking.duration }}{{ 'Units.Minutes' | translate | lowerCase }}</span>
													<span *ngIf="vm.isPrescription">/{{ 'Booking.Prescription.Prescription' | translate | lowerCase }}</span>
												</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-100 u-no-p u-ost-md" *ngIf="vm.booking.languages?.length">
												<div class="o-grid">
													<div class="o-grid__cell u-no-p">
														<list-language-flags [languages]="vm.booking.languages"></list-language-flags>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="vm.booking.isCoveredByBusinessWallet">
														<div [ngClass]="{'c-label--s0':  vm.booking.walletName?.toLowerCase() === 'iizi', 'c-label--s2':  vm.booking.walletName?.toLowerCase() !== 'iizi'}" class="c-label c-label--s4">
															<i [ngClass]="{'o-icon--check':  vm.booking.walletName?.toLowerCase() === 'iizi', 'o-icon--user':  vm.booking.walletName?.toLowerCase() !== 'iizi'}" class="o-icon" aria-hidden="true"></i>
															{{ vm.booking.walletName ? (vm.getBusinessWalletLabel() | translate).replace('%s', vm.booking.walletName) : ('Services.Other.Covered_By_Employer' | translate) }}
														</div>
													</div>
												</div>
											</div>
											<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--o2 u-no-p u-ost-md" *ngIf="!vm.booking.languages?.length && vm.booking.isCoveredByBusinessWallet">
												<div class="o-grid">
													<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-no-p">
														<div [ngClass]="{'c-label--s0':  vm.booking.walletName?.toLowerCase() === 'iizi', 'c-label--s2':  vm.booking.walletName?.toLowerCase() !== 'iizi'}" class="c-label c-label--s4">
															<i [ngClass]="{'o-icon--check':  vm.booking.walletName?.toLowerCase() === 'iizi', 'o-icon--user':  vm.booking.walletName?.toLowerCase() !== 'iizi'}" class="o-icon" aria-hidden="true"></i>
															{{ vm.booking.walletName ? (vm.getBusinessWalletLabel() | translate).replace('%s', vm.booking.walletName) : ('Services.Other.Covered_By_Employer' | translate) }}
														</div>
													</div>
												</div>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
			<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
				<section class="c-section u-no-p" panel>
					<div class="c-section__header u-hidden@md-and-up">
						<h2 class="c-section__title c-section__title--sm">{{ 'Booking.Problem_Description' | translate }}</h2>
					</div>
					<div class="c-section__content">
						<div class="o-grid">
							<div class="o-grid__cell c-cell">
								<div class="c-card" *ngIf="vm.booking">
									<div class="c-content" *ngIf="!vm.isPrescription">
										<p class="c-text">{{ vm.booking.comment }}</p>
									</div>
									<div class="c-content" *ngIf="vm.isPrescription">
										<div class="o-grid u-osb-xs">
											<div class="o-grid__cell o-grid__cell--slim u-no-pl">
												<p class="c-text c-text--gray">{{ 'Booking.Prescription.Name' | translate }}</p>
											</div>
											<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--slim u-no-pr">
												<p class="c-text c-text--right c-text--wrap">{{ vm.booking.prescriptionRequest?.drug?.name || vm.booking.prescriptionRequest?.drugIngredient?.name }}</p>
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</div>
				</section>
			</div>
		</div>
	</div>
	<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-67@md-and-up u-no-p">
		<div class="o-grid">
			<div class="o-grid__cell u-no-p">
				<section class="c-section c-section--last" [ngClass]="{ 'c-section--error': (vm.submitted && mainForm.invalid) }" panel
								 [isOpen]="vm.isOpen?.consents">
					<div class="c-section__header">
						<h2 class="c-section__title c-section__title--sm">{{ 'Booking.Overview' | translate }}</h2>
					</div>
					<div class="c-section__content" *ngIf="vm.booking">
						<div class="o-grid">
							<div class="o-grid__cell u-no-p@up-to-md">
								<div class="c-card" [ngClass]="{ 'c-card--error': (vm.submitted && mainForm.invalid) }">
									<div class="c-content c-content--lg" *ngIf="vm.booking?.coPay && !vm.booking?.claimsNotSupported">
										<item-notification icon="attention" [text]="vm.getInsuranceCoPayInfo()" [theme]="5"></item-notification>
									</div>
									<div class="c-content c-content--lg" *ngIf="vm.booking?.coPay && vm.booking?.claimsNotSupported">
                                        <item-notification icon="attention" [text]="vm.getInsuranceCoPayInfoWithClaimsNotSupported()" [theme]="5"></item-notification>
                                    </div>
                                    <div class="c-content c-content--lg" *ngIf="!vm.canPayWithBusinessWallet && vm.leftToPay > 0 && vm.insuranceWalletDisabledForThirdPerson">
                                        <item-notification icon="attention" [text]="vm.getWalletDisabledForThirdPersonWarning()" [theme]="5"></item-notification>
                                    </div>
                                    <div class="c-content c-content--lg" *ngIf="!vm.canPayWithBusinessWallet && vm.leftToPay > 0 && vm.insuranceWalletDisabledForInvalidPeriod">
                                        <item-notification icon="attention" [text]="vm.getInsuranceWalletDisabledForInvalidPeriodWarning()" [theme]="5"></item-notification>
                                    </div>
									<div class="c-content">
										<div class="o-grid o-grid--wrap">
											<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-45@md-and-up u-no-p">
												<div class="o-grid">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Service' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p class="c-text c-text--right c-text--s2" *ngIf="vm.isHomeVisit">{{ 'Booking.Home_Visit' | translate }}</p>
														<p class="c-text c-text--right c-text--s2" *ngIf="vm.isPrescription">{{ 'Booking.Prescription.Prescription' | translate }}</p>
														<p class="c-text c-text--right c-text--s2" *ngIf="!vm.isHomeVisit && !vm.isPrescription && vm.booking?.communicationType">{{ 'Booking.CommunicationType.' + vm.booking.communicationType | translate }}</p>
													</div>
												</div>
												<div class="o-grid" *ngIf="vm.isForCareTaken">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Service_Child' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p id="careTakenInfoLabel" class="c-text c-text--right c-text--s2">{{ vm.booking.careTakenInfo.name }} ({{ vm.booking.careTakenInfo.personalCode }})</p>
													</div>
												</div>
												<div class="o-grid">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Date' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p class="c-text c-text--right c-text--s2">{{ vm.booking.date }}</p>
													</div>
												</div>
												<div class="o-grid" *ngIf="vm.booking.start && vm.booking.end">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Time' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p class="c-text c-text--right c-text--s2">{{ vm.booking.start }} - {{ vm.booking.end }} ({{ vm.booking.duration }} {{ 'Units.Minutes' | translate | lowerCase }})</p>
													</div>
												</div>
											</div>
											<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-10@md-and-up u-ost-md@up-to-md">
												<div class="c-divider c-divider--v"></div>
											</div>
											<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-45@md-and-up u-no-p">
												<div class="o-grid" *ngIf="!(vm.businessWallet && vm.canPayWithBusinessWallet)">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Your_Balance' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p class="c-text c-text--right">{{vm.balance?.balance || '0' }}{{vm.balance?.currency || vm.booking.currency | currency}}</p>
													</div>
												</div>
												<div class="o-grid" *ngIf="vm.user?.origin == 'minudoc.ee' && vm.businessWallet && vm.canPayWithBusinessWallet && !vm.businessWallet?.sessionLimit">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--gray u-no-wrap">{{ vm.booking.walletName ? ('Booking.Title.Business_Wallet_Limit' | translate).replace('%s', vm.booking.walletName) : ('Booking.Title.Employer_Limit' | translate) }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p class="c-text c-text--right">{{vm.businessWallet.balance || '0' }}{{vm.businessWallet.currency | currency}}</p>
													</div>
												</div>
												<div class="o-grid" *ngIf="vm.businessWallet?.sessionLimit">
                                                    <div class="o-grid__cell u-no-pl">
                                                        <p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Sessions_Used' | translate }}</p>
                                                    </div>
                                                    <div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
                                                        <p class="c-text c-text--right c-text--s2">{{ vm.businessWallet.sessionsUsed ? vm.businessWallet.sessionsUsed : 0 }}/<span class="c-text--bold">{{ vm.businessWallet.sessionLimit }}</span></p>
                                                    </div>
                                                </div>
												<div class="o-grid" *ngIf="vm.user?.origin == 'minudoc.ee' || !(vm.businessWallet && vm.canPayWithBusinessWallet)">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--lg c-text--bold c-text--uppercase u-no-wrap">{{ 'Booking.Total' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p">
														<p id="totalPriceLabel" class="c-text c-text--lg c-text--bold c-text--right c-text--main">{{vm.booking.price}}{{vm.booking.currency}}</p>
													</div>
												</div>
												<div class="o-grid" *ngIf="vm.booking.bookingStart && vm.mode !== 'RESERVATION_BOOKING'">
													<div class="o-grid__cell u-no-pl">
														<p class="c-text c-text--bold c-text--s3" *ngIf="vm.isBookingExpired">{{ 'Booking.Expired' | translate }}</p>
														<p class="c-text c-text--bold c-text--s3" *ngIf="!vm.isBookingExpired ">{{ 'Booking.Time_Left' | translate }}</p>
													</div>
													<div class="o-grid__cell o-grid__cell--w-fixed u-no-p" *ngIf="!vm.isBookingExpired">
														<p class="c-text c-text--bold c-text--right c-text--s3">{{ vm.bookingExpiresIn }}</p>
													</div>
												</div>
											</div>
										</div>
									</div>
									<div class="c-content u-hidden@up-to-md" *ngIf="!vm.isPrescription && !vm.isHomeVisit && vm.booking && (vm.booking.communicationType === 'VIDEO' || vm.booking.communicationType === 'AUDIO')">
										<item-notification icon="video" [text]="('Call.Other.Test_Request' | translate)" [btnText]="('Call.Other.Test' | translate)" [href]="vm.avTestUrl" [theme]="1"></item-notification>
									</div>
									<div class="c-content u-hidden@up-to-md" *ngIf="!vm.isPrescription && !vm.isHomeVisit && vm.booking && vm.booking.communicationType === 'FACE_TO_FACE'">
										<item-notification icon="home" [text]="('Call.Other.Home_Visit' | translate)" [theme]="1"></item-notification>
									</div>
									<div class="c-divider c-divider--h@up-to-md u-hidden@md-and-up"></div>
                                    
                                    <div class="c-content c-content--wrapper" *ngIf="!vm.canPayWithBusinessWallet && vm.booking.service && vm.booking.service.discountPricingSupported" style="min-height:106px">
                                        <div class="o-grid__cell u-no-pl">
                                            <p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Discount_Code.Text' | translate }}</p>
                                        </div>
                                        <form id="discount-check-form" class="o-grid o-grid--wrap" style="margin-top:5px;">
                                            <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-60@md-and-up u-no-p">
                                                <input type="text" id="dicountCode" name="dicountCode" class="c-form__input" [(ngModel)]="vm.discountCode" />
                                                <p *ngIf="vm.discountError" id="discount-check-error" role="alert" style="color:#ff0000;text-align:left;font-size:13px;line-height:17px;margin-left:2px;">{{ 'Booking.Discount_Code.Error' | translate }}</p>
                                                <p *ngIf="vm.discountSuccess" id="discount-check-success" role="alert" style="color:#008000;text-align:left;font-size:13px;line-height:17px;margin-left:2px;">{{ 'Booking.Discount_Code.Success' | translate }}</p>
                                            </div>
                                            <div class="o-grid__cell o-grid__cell--w-5 u-no-p u-hidden@up-to-md"></div>
								            <div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-35@md-and-up u-no-p u-ost-md@up-to-md">
								                <button id="discountSubmitButton" type="button" style="padding-top:10px;padding-bottom:10px;" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.handleDiscountCheck()" [disabled]="vm.isBookingExpired || vm.isProcessing">{{ 'Booking.Discount_Code.Check' | translate }}</button>
								            </div>
                                        </form>
                                    </div>
									<div class="c-divider c-divider--h@up-to-md u-hidden@md-and-up" *ngIf="!vm.canPayWithBusinessWallet && vm.booking.service && vm.booking.service.discountPricingSupported"></div>
									
									<div class="c-content c-content--wrapper" *ngIf="vm.walletProcessed && !vm.canPayWithBusinessWallet && vm.leftToPay > 0 && vm.isStripeEnabled()" style="min-height:106px">
										<div class="o-grid__cell u-no-pl">
											<p class="c-text c-text--gray u-no-wrap">{{ 'Booking.Enter_Credit_Card' | translate }}</p>
										</div>
										<form id="payment-form" style="margin-top:5px;">
											<div id="card-element" style="border-radius:4px 4px 0 0;padding:12px;border:1px solid rgba(50, 50, 93, 0.1);height:44px;width:100%;background:white;">
												<!--Stripe.js injects the Card Element-->
											</div>
											<p id="card-error" role="alert" style="color:#ff0000;text-align:left;font-size:13px;line-height:17px;margin-left:2px;"></p>
										</form>
									</div>
									
									<form class="c-form" name="vm.form" [formGroup]="mainForm">
										<div class="c-content c-content--wrapper" *ngIf="vm.walletProcessed && !vm.canPayWithBusinessWallet && vm.leftToPay > 0 && !vm.isStripeEnabled()" style="min-height:106px">
											<list-banklinks [booking]="vm.booking" [(reloadNeeded)]="vm.banklinksReloadNeeded" [(banklinks)]="vm.banklinks" [(activeBanklink)]="vm.banklink" [isRequired]="true" *ngIf="vm.booking.id"></list-banklinks>
											<p class="c-text c-text--s3 u-ost-sm" *ngIf="vm.submitted && !vm.banklink">{{ 'Booking.Choose_Payment_Method' | translate }}</p>
											<loader-overlay *ngIf="!vm.banklinks || !vm.booking.id"></loader-overlay>
										</div>
										
										<div class="c-content">
											<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('termsCheckbox').invalid) }">
												<label class="c-checkbox">
													<input id="termsCheckbox" formControlName="termsCheckbox" type="checkbox" name="terms">
													<span id="termsConsentLabel" [innerHTML]="vm.termsConsent"></span>
												</label>
											</div>
											<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('ppCheckbox').invalid) }">
												<label class="c-checkbox">
													<input id="ppCheckbox" formControlName="ppCheckbox" type="checkbox" name="pp">
													<span id="ppConsentLabel" [innerHTML]="vm.ppConsent"></span>
												</label>
											</div>
											<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('dataProcessingCheckbox').invalid) }" *ngIf="vm.dataProcessingAcceptedVisible">
												<label class="c-checkbox">
													<input id="dataProcessingCheckbox" formControlName="dataProcessingCheckbox" type="checkbox" name="processing">
													<span id="dataProcessingConsentLabel">{{ 'Modal.Content.Data_Processing' | translate }} <span *ngIf="vm.dataProcessingAcceptedRequired">*</span></span>
												</label>
											</div>
											<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('dataStorageTimeCheckbox').invalid) }" *ngIf="vm.dataStorageTimeAcceptedVisible">
												<label class="c-checkbox">
													<input id="dataStorageTimeCheckbox" formControlName="dataStorageTimeCheckbox" type="checkbox" name="storageTime">
													<span id="dataStorageTimeConsentLabel">{{ 'Modal.Content.Data_Storage_Time' | translate }} <span *ngIf="vm.dataStorageTimeAcceptedRequired">*</span></span>
												</label>
											</div>
											<div class="c-form__group u-osb-sm" [ngClass]="{ 'c-form__group--error': (vm.submitted && mainForm.get('dataSharingCheckbox').invalid) }" *ngIf="vm.dataSharingAcceptedVisible">
												<label class="c-checkbox">
													<input id="dataSharingCheckbox" formControlName="dataSharingCheckbox" type="checkbox" name="storageTime">
													<span id="dataSharingConsentLabel">{{ 'Modal.Content.Data_Sharing_Accepted' | translate }} <span *ngIf="vm.dataSharingAcceptedRequired">*</span></span>
												</label>
											</div>
		                                    <div *ngIf="vm.gdprDisclaimerVisible">
		                                        <item-notification icon="attention" [text]="vm.gdprDisclaimerTranslated" [theme]="5"></item-notification>
		                                    </div>
										</div>
									</form>
								</div>
							</div>
						</div>
						<loader-overlay [theme]="1" *ngIf="vm.isProcessing || vm.addingFundsInProgress"></loader-overlay>
					</div>
				</section>
			</div>
		</div>
		<div class="o-grid u-ost-md" *ngIf="!vm.gdprDisclaimerVisible">
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right">
				<p class="c-text c-text--sm">{{'Modal.Content.YouCanAlwaysWithdraw' | translate}} <a [routerLink]="['/consents']" target="_blank" (click)="$event.stopPropagation()">{{ 'Components.Header.Button.Manage_Consents' | translate }}</a></p>
			</div>
		</div>
		<div class="o-grid u-ost-md" *ngIf="vm.walletProcessed">
			<div class="o-grid__cell u-hidden@up-to-md"></div>
			<div class="o-grid__cell o-grid__cell--w-fixed o-grid__cell--right u-hidden@up-to-md">
				<a id="bookingCheckoutBackButton" [routerLink]="vm.booking.backUrl" [queryParams]="vm.booking.queryParams" class="c-button c-button--link c-button--lg">{{ 'Booking.Button.Back' | translate }}</a>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right" *ngIf="vm.canPayWithBusinessWallet && !vm.businessWalletErrors.userLimitExceeded">
				<button id="businessWalletCompleteButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.handleFormSubmit()" [disabled]="vm.isBookingExpired || vm.isProcessing">{{ vm.booking.walletName ? ((vm.booking.insuranceWallet ? 'Booking.Pay_Insurance_Wallet_Balance' : 'Booking.Pay_Business_Wallet_Balance') | translate).replace('%s', vm.booking.walletName) : ('Booking.Button.Confirm' | translate) }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right" *ngIf="(!vm.canPayWithBusinessWallet || vm.businessWalletErrors.userLimitExceeded) && (!vm.leftToPay || vm.leftToPay < 0)">
				<button id="noPaymentCompleteButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.handleFormSubmit()" [disabled]="vm.isBookingExpired || vm.isProcessing">{{ (vm.booking.price ? 'Booking.Pay_User_Balance' : 'Booking.Button.Confirm') | translate }}</button>
			</div>
			<div class="o-grid__cell o-grid__cell--w-100 o-grid__cell--w-fixed@md-and-up o-grid__cell--right" *ngIf="!vm.canPayWithBusinessWallet && vm.leftToPay > 0">
				<button id="privateWalletCompleteButton" type="button" class="c-button c-button--s2 c-button--fit c-button--lg" (click)="vm.handlePayment()" [disabled]="vm.isBookingExpired || vm.isProcessing || vm.addingFundsInProgress">{{ 'Booking.Button.Confirm' | translate }}</button>
			</div>
		</div>
	</div>
</div>
